module.exports = __webpack_public_path__ + "media/images/v2/Background2-5ae9bea1790ce84942b17334f2f7e8e3.jpg";